import { AppState } from "../app.state";
import { createSelector } from "reselect";

export const getLoginStatus = (state: AppState) => state.login.loadStatus;

export const getToken = (state: AppState) => state.login.token;

export const getIsLoggedIn = createSelector([getToken], (token: string) => !!token);
